import { useMutation } from '@tanstack/react-query';
import { useRequestSections } from '../api/request';
import { useDispatch, useSelector } from 'react-redux';
import { setPermission } from '../redux/reducer/permissionReducer';
import { RootState } from '../redux/Store';

const usePermissions = () => {
  const { Permission } = useRequestSections();
  const dispatch = useDispatch();
  const permissions = useSelector(
    (state: RootState) => state?.permissions?.permissionData
  );

  const {
    mutateAsync: getPermission,
    isPending: isPermissionPending,
    error: getPermissionError,
    isSuccess: successfulGetPermission,
    data: getPermissionData,
  } = useMutation({
    mutationFn: async () => {
      const response = await Permission?.getPermission();
      dispatch(setPermission(response?.data?.functions));
      return response?.data?.functions;
    },
  });

  return {
    getPermission,
    isPermissionPending,
    getPermissionError,
    successfulGetPermission,
    getPermissionData,
  };
};

export default usePermissions;
